module.exports = "https://static.wagwalking.com/_next/static/images/states-map-ce2fa1cde553b83ca500f54afb7b46d2.svg";